<template>
  <div>
      <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="radioFmInfo"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="默认显示人次" prop="virtual_number">
        <el-input v-model="radioFmInfo.virtual_number" style="width:220px" :disabled="is_disables"></el-input>
      </el-form-item>

      <el-form-item label="节目日期">
        <el-date-picker
            v-model="radioFmInfo.days"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择节目日期"
            :disabled="is_disables"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="播放开始时间">
        <el-time-picker
            v-model="radioFmInfo.begin_at"
            :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
             }"
            value-format="HH:mm:ss"
            placeholder="选择播放时间"
            :disabled="is_disables"
        >
        </el-time-picker>
      </el-form-item>

      <el-form-item label="添加节目">
         <el-button @click="addItem()" type="primary">+</el-button>
      </el-form-item>


      <div v-for="(item, index) in radioFmInfo.dynamicItem" :key="index">
        <el-form-item :label="'节目'+ (index+1)">
          <el-input v-model="item.title" style="width: 23%" disabled></el-input>
          <el-button
              type="primary"
              size="small"
              @click="
          search.chooseOrgVisible = true;
          searchData(index);
        "
              style="margin-left:10px">
            查询
          </el-button>
          <span v-if="item.duration" style="margin-left:10px;margin-right: 10px;">(播放结束时间: {{item.duration}})</span>
          <el-button class="el-icon-delete" @click="deleteItem(item, index)"></el-button>
        </el-form-item>

      </div>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="
            createUpdateRadioFm()
          "
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>


    <el-dialog
        title="添加节目"
        :visible.sync="search.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnClose"
        width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="search.query.search"
              placeholder="请输入标题"
              clearable
              @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="课程" name="1"></el-tab-pane>
        <el-tab-pane label="读书音频" name="6"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
          border
          :data="search.result.data"
          highlight-current-row
          v-loading="search.listLoading1"
          style="..."
          @expand-change="expandChange"
      >
        <el-table-column type="expand" >
          <template slot-scope="props">
            <el-table border v-loading="search.periodsListLoading" :data="props.row.breBroodsList" size="mini" style="width: 92%;margin-left: 4%;">
              <el-table-column prop="id" label="ID" align="center"></el-table-column>
              <el-table-column prop="type" label="类型" ></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column prop="duration_time" label="时长"></el-table-column>
              <el-table-column prop="file_size" label="文件大小"></el-table-column>
              <el-table-column prop="created_at" label="创建时间"></el-table-column>
              <el-table-column label="操作" align="center" width="200">
                <template slot-scope="{ row }">
                  <el-button type="primary" size="small" @click="selectProduct(row)">
                    确定
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="pageSearchData"
          :current-page.sync="search.query.page"
          :page-size="search.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  createUpdateRadioFm,
  radioFmInfo,
  getPeriodList,
  formatDate,
  screenCourseList
} from "@/api/radioFm";

export default {
  data: function () {
    return {
      now_index: 0,
      bannerTargetList: [],
      loading: false,
      updateLoading: false,
      editor: null,
      chooseOrgVisible: false,
      is_disables: false,
      theTargetId:'',
      theTargetTitle:'',
      radioFmInfo: {
        id: 0,
        virtual_number: 0,
        days: "",
        begin_at: "",
        dynamicItem: [],
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        periodsListLoading: false,
        activeName: "1",
        query: {
          search: "",
          page: 1,
          limit: 20,
          target_type: 1,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.radioFmInfo.id = this.$route.query.id;
    if (this.radioFmInfo.id > 0) {
      this.getInfo();
      this.is_disables = true
    }
  },
  mounted() {
  },
  methods: {
    addItem () {
      this.radioFmInfo.dynamicItem.push({
        id: 0,
        target_id: '',
        target_periods_id: '',
        title: '',
        duration_stamp: 0,
        duration: '',
      })
    },

    deleteItem (item, index) {
      this.radioFmInfo.dynamicItem.splice(index, 1)
    },

    getInfo() {
      this.loading = true;
      radioFmInfo({
        id: this.radioFmInfo.id,
      }).then((response) => {
        this.radioFmInfo = response.data;
        this.loading = false;
      });
    },
    createUpdateRadioFm() {
      console.log(this.radioFmInfo.dynamicItem);
      this.updateLoading = true;
      createUpdateRadioFm(this.radioFmInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/radioFm/list",
              query: {
                page: 1,
                limit: 20,
              }
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },

    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData(this.now_index);
    },

    pageSearchData() {
      this.searchData(this.now_index);
    },

    // 查询方法
    searchData(index) {
      console.log(index)
      this.now_index = index;
      this.search.listLoading1 = true;
      screenCourseList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
        for (var i in response.data.list) {
          let val = response.data.list[i];
          this.$set(val, 'breBroodsList', [])
        }
      });
    },

    /**点击主表格行，获取子表格明细**/
    expandChange(val) {
      console.log(val)
      val.breBroodsList = undefined;
      this.theTargetId = val.id;
      this.theTargetTitle = val.title;
      this.search.periodsListLoading = true;
      if (val.breBroodsList == undefined) {
        getPeriodList({course_id: val.id}).then(res => {
          this.$set(val, 'breBroodsList', res.data)
          this.search.periodsListLoading = false;
        })
      }
    },
    selectProduct(row) {
      console.log(this.now_index)
      var days = this.radioFmInfo.days;
      var time = this.radioFmInfo.begin_at;
      if (row.is_free == 1) {
        this.$confirm("有需付费章节被选中（"+row.title+"），将会被免费播放是否确认", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          if (days == '') {
            this.$message({
              message: '节目日期不能为空',
              type: "error",
            });
            this.addEditFormOnClose();
            return;
          }
          if (time == '') {
            this.$message({
              message: '播放开始时间不能为空',
              type: "error",
            });
            this.addEditFormOnClose();
            return;
          }
          var date = (new Date(days + ' ' + time)).getTime() / 1000

          var duration = row.duration
          // eslint-disable-next-line no-unused-vars
          var duration_stamp = 0
          if (this.now_index == 0) {
            duration_stamp = date + duration
          } else {
            duration_stamp = (this.radioFmInfo.dynamicItem[(this.now_index) - 1].duration_stamp) + duration
          }
          console.log(date, duration_stamp)
          this.radioFmInfo.dynamicItem[this.now_index].target_id = this.theTargetId
          this.radioFmInfo.dynamicItem[this.now_index].target_periods_id = row.id
          this.radioFmInfo.dynamicItem[this.now_index].title = this.theTargetTitle + '-' + row.title
          this.radioFmInfo.dynamicItem[this.now_index].duration_stamp = duration_stamp
          this.radioFmInfo.dynamicItem[this.now_index].duration = formatDate(new Date(duration_stamp * 1000), 'hh:mm:ss')
          this.addEditFormOnClose();
        });
      } else {
        if (days == '') {
          this.$message({
            message: '节目日期不能为空',
            type: "error",
          });
          this.addEditFormOnClose();
          return;
        }
        if (time == '') {
          this.$message({
            message: '播放开始时间不能为空',
            type: "error",
          });
          this.addEditFormOnClose();
          return;
        }
        var date = (new Date(days + ' ' + time)).getTime() / 1000

        var duration = row.duration
        // eslint-disable-next-line no-unused-vars
        var duration_stamp = 0
        if (this.now_index == 0) {
          duration_stamp = date + duration
        } else {
          duration_stamp = (this.radioFmInfo.dynamicItem[(this.now_index) - 1].duration_stamp) + duration
        }
        console.log(date, duration_stamp)
        this.radioFmInfo.dynamicItem[this.now_index].target_id = this.theTargetId
        this.radioFmInfo.dynamicItem[this.now_index].target_periods_id = row.id
        this.radioFmInfo.dynamicItem[this.now_index].title = this.theTargetTitle + '-' + row.title
        this.radioFmInfo.dynamicItem[this.now_index].duration_stamp = duration_stamp
        this.radioFmInfo.dynamicItem[this.now_index].duration = formatDate(new Date(duration_stamp * 1000), 'hh:mm:ss')
        this.addEditFormOnClose();
      }
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.type = 1;
      this.search.activeName = "1";
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>